import React from 'react'


const textStyles = {fill: 'yellow', fontSize: '100', fontFamily: 'Montserrat Alternates, sans-serif', margin: '10px', textDecoration: 'none'}
let headingStyles = {marginTop: '150px', fontSize: '130px', fontFamily: 'Montserrat Alternates, sans-serif'}

if (window.screen.width<=1200) {
    headingStyles['fontSize'] = '300%'
}

// let left = '0'
// let right = '0'
let widthh = '170%'
let heightt = '100%'
if (window.screen.width>1200) {
    // left = '50%'
    // right = 720*(window.screen.width/1000) + 'px'
    widthh = 2000*(window.screen.width/1000) + 'px'
    heightt = 1600*(window.screen.width/1000) + 'px'
}

const Title = () => {


  

    return (
        <div style={{height:'100vh', overflow: 'hidden', position: 'relative'}}>
            <h1 style={headingStyles} >Nicholas Hammond</h1>
            <a style={textStyles} href="https://github.com/Nickphammond">Github</a>
            <a style={textStyles} href="https://www.linkedin.com/in/nicholas-hammond-90828018b/">Linkedin</a>


            <svg viewBox={'0 0 1000 1000'} style={{overflow: 'hidden', fontSize: '0', backgroundColor: "honeydew", position: 'absolute', top:'0', left:'-100', zIndex:'-2'}} width={widthh} height={heightt}>
            {/* <path id='rainbow' d={'M100 300 '
                        + ' A 50 50 0 0 1 400 300 '  
                        
                        } 
            fill={'none'} stroke={'#C8CD04'} strokeWidth={'5'}/> */}


            <path id='bgShape' d={

                'M -200 800' +
                'L 0 785   Q 65 780  100 740  ' +
                'L 100 740   Q 270 600  640 800  ' +
                '' 
                 
                        } 
            fill={'#D6F4F0'} stroke={'none'} strokeWidth={'1'}/>


            <path id='triangles1' d={
                
                'M 200 400  L 250 450  L 150 450  L 200 400' +
                'M 250 450  L 300 500  L 200 500  L 250 450' +
                'M 300 500  L 250 550  L 150 550  L 200 500' +
                'M 350 550  L 400 600  L 300 600  L 350 550' +
                'M 400 600  L 470 670  L 330 670  L 400 600' +
                'M 470 670  L 520 720  L 420 720  L 470 670'
                +

                'M 100 400  L 150 450  L 50 450  L 100 400' +
                'M 150 450  L 200 500  L 100 500  L 150 450' +
                'M 200 500  L 250 550  L 150 550  L 200 500' +
                'M 250 550  L 300 600  L 200 600  L 250 550' +
                'M 300 600  L 370 670  L 230 670  L 300 600'  
                +

                'M 50 450  L 100 500  L 0 500  L 50 450' +
                'M 100 500  L 170 570  L 30 570  L 100 500' +
                'M 170 570  L 208 608  L 132 608  L 170 570' 

                +

                'M 132 608  L 182 658  L 82 658  L 132 608' +
                'M 182 658  L 282 758  L 82 758  L 182 658' +
                'M 282 758  L 342 818  L 222 818  L 282 758' +
                'M 342 818  L 402 878  L 282 878  L 342 818' +
                'M 402 878  L 442 918  L 362 918  L 402 878'

                +
                'M 232 828  L 282 878  L 182 878 L 232 828' +
                'M 282 878  L 332 928  L 232 928 L 282 878'

                +
                'M -60 480  L 30 570  L -150 570  L -60 480' +
                'M -10 570  L 82 658  L -102 658  L -10 570' +
                'M 82 758  L 172 848  L -12 848  L 82 758'
                 
                        } 
            fill={'#F3B3BE'} stroke={'none'} strokeWidth={'1'}/>



            <path id='triangles2' d={
                
                'M 200 475  L 210 465  L 190 465  L 200 475' +
                'M 100 490  L 130 460  L 70 460  L 100 490' 
                 
                        } 
            fill={'black'} stroke={'none'} strokeWidth={'1'}/>




            </svg>


        </div>
    )
}


export default Title